import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
import { heroFacts, mockups } from '../data/content';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section id="top" className="w-full bg-white pb-16 pt-12 md:pb-20 md:pt-16" data-id="element-86" data-mp="9luyujz7c3so">
      <div className="mx-auto w-full max-w-content px-5 text-center md:px-8" data-id="element-87" data-mp="4m8kg77n0hia">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease
      }} className="inline-flex items-center gap-2 rounded-full bg-amber-100 px-4 py-2 font-display text-[0.7rem] font-extrabold uppercase tracking-[0.16em] text-amber-700 ring-1 ring-amber-200" data-id="element-88" data-mp="129h6c3bjvskt">
          <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-89" data-mp="nbonp2apio2e" />
          Solución profesional para salud mental
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.05,
        ease
      }} className="mx-auto mt-6 max-w-4xl font-display text-[2.35rem] font-extrabold leading-[1.04] tracking-tight text-night sm:text-5xl md:text-[3.5rem]" data-id="element-90" data-mp="3cz5wsfzj282g">
          Transformá tu campaña de Septiembre Amarillo en{' '}
          <span className="bg-amber-400 px-1.5 pb-0.5 leading-tight text-night" data-id="element-91" data-mp="39cpboqkkxd0s">
            una experiencia que salva vidas
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        delay: 0.1,
        ease
      }} className="mx-auto mt-6 max-w-3xl font-display text-xl font-bold leading-snug text-gray-700 md:text-2xl" data-id="element-92" data-mp="30h9dxygpedpx">
          El único megakit 3 en 1 con 120 tarjetas, mazo reflexivo y marcadores listos para imprimir
        </motion.p>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.14,
        ease
      }} src={mockups.kit} alt="Kit completo 3 en 1: baraja del Septiembre Amarillo, 120 tarjetas de mensajes y 120 marcadores de página" className="mx-auto mt-10 w-full max-w-3xl rounded-3xl shadow-lift" width={1256} height={1256} data-id="element-93" data-mp="2hjowhcg9qhfc" />

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        delay: 0.2,
        ease
      }} className="mx-auto mt-11 max-w-3xl" data-id="element-94" data-mp="ddngm482ivl0">
          <p className="mx-auto max-w-2xl text-lg leading-relaxed text-gray-600" data-id="element-95" data-mp="162ued0zp7h57">
            120 tarjetas con mensajes que abren el corazón. Entregá una por una o transformalas en
            regalos con bombones, caramelos, lapiceros. La forma más simple de esparcir esperanza.
          </p>

          <ul className="mt-9 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-sm font-semibold text-gray-500" data-id="element-96" data-mp="3lt740mm25js5">
            {heroFacts.map((fact, index) => <li key={fact} className="inline-flex items-center gap-3" data-id="element-97" data-mp="1x9kw0qpijcjb" data-mpi={index}>
                {index > 0 && <span className="h-1 w-1 rounded-full bg-gray-300" aria-hidden="true" data-id="element-98" data-mp="21aekbl6vatcq" />}
                {fact}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}